import { Fragment, h } from "preact";
import { HintStepView } from "../common/components/HintStepView";
import { KeywordInput } from "../common/components/KeywordInput";
import { ModalView } from "../common/components/ModalView";
import { StepButtons } from "../common/components/StepButtons";
import { useManagerV2 } from "../common/hooks/useManagerV2";
import { hintSiteConfig } from "./config/hints";
import "./styles.scss";

export function App() {
  const {
    submitKeyword,
    currentStepKey,
    setCurrentStepKey,
    currentStep,
    visibleButtons,
    keywordSubmitError,
    resetSubmitError,
    userDefinedInlineNotice,
    modalContent,
    closeModal,
  } = useManagerV2(hintSiteConfig);

  return (
    <Fragment>
      <main>
        <h1 style="padding-top:20px;padding-bottom:20px">
          <img
            src="./img/logo.png"
            style="max-height:300px;max-width:90%;"
          ></img>
          <br></br>
          ヒントサイト
        </h1>

        <p style="text-align:center;margin-bottom:-5px">
          キーワードを入力してください
        </p>
        <KeywordInput
          onSubmit={submitKeyword}
          keywordSubmitError={keywordSubmitError}
          resetSubmitError={resetSubmitError}
          userDefinedInlineNotice={userDefinedInlineNotice}
        />
        <StepButtons
          visibleButtons={visibleButtons}
          onSelect={setCurrentStepKey}
          selected={currentStepKey}
        />
        <div className="hint_display">
          <HintStepView stepKey={currentStepKey} step={currentStep} />
        </div>
      </main>
      <ModalView contents={modalContent} onClose={closeModal} />
    </Fragment>
  );
}
